import React, { Fragment, useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { toast } from "react-hot-toast";
import { AiFillEye, AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import { hasPermission } from "../../../utils/hasPermission";
import {
  useAcceptCouponsRequestsMutation,
  useGetAllCouponsRequestsMutation,
  useGetTokenMutation,
  useRejectCouponsRequestsMutation,
  useCheckCouponStatusMutation,
  useUpdateCouponStatusMutation,
} from "../../../features/tenant/OzoneAPI/ozoneApi";
import {
  useGetBatchApprovalStatusMutation,
  useGetApprovalLogsByRefMutation,
} from "../../../features/tenant/approvalLog/approvalLog.Api";
import { getVendorName } from "../../../utils/getVendorName";
import CustomExport from "../../../components/CustomExport/CustomExport";

const DynamicCouponRequestList = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const [checkStatusModal, setCheckStatusModal] = useState(false);

  const acceptCouponRequestPermission = hasPermission("acceptRequest");
  const rejectCouponRequestPermission = hasPermission("rejectRequest");

  const [selectedCouponRequest, setSelectedCouponRequest] = useState(null);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);

  const [totalRows, setTotalRows] = useState(0);
  const [totalData, setTotalData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [prevPage, setPrevPage] = useState(0);
  const isVoucher = window.location.pathname.toLowerCase().includes("voucher");

  const [rowWorkflowStatus, setRowWorkflowStatus] = useState({});
  const [historyModal, setHistoryModal] = useState(false);
  const [historyRow, setHistoryRow] = useState(null);
  const [historyLogs, setHistoryLogs] = useState([]);
  const [actionModal, setActionModal] = useState({
    isOpen: false,
    type: "", // "approve" | "reject" | "resolve"
    rowId: null,
    isFinalApproval: false,
    remarks: "",
    couponCode: "",
    validUpto: "",
  });

  const handleOpenActionModal = (row, type) => {
    const ws = rowWorkflowStatus[row.id];
    let isFinalApproval = false;
    if (!ws || ws.no_workflow) {
      isFinalApproval = true;
    } else {
      isFinalApproval = ws.current_level === ws.total_levels;
    }

    setActionModal({
      isOpen: true,
      type,
      rowId: row.id,
      isFinalApproval,
      remarks: "",
      couponCode: "",
      validUpto: "",
    });
  };

  const [getBatchApprovalStatus] = useGetBatchApprovalStatusMutation();
  const [
    getApprovalLogsByRef,
    { data: approvalLogsData, isLoading: approvalLogsLoading },
  ] = useGetApprovalLogsByRefMutation();

  const fetchBatchWorkflowStatus = async (rows) => {
    if (!rows || rows.length === 0) return;
    try {
      const res = await getBatchApprovalStatus({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        ref_table_name: "coupon_sent_status",
        ref_ids: rows.map((r) => r.id),
      }).unwrap();
      if (res?.body) setRowWorkflowStatus(res.body);
    } catch (e) {
      console.error("batch workflow status error", e);
    }
  };

  const openHistory = (row) => {
    setHistoryRow(row);
    setHistoryLogs([]);
    setHistoryModal(true);
    getApprovalLogsByRef({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      ref_table_name: "coupon_sent_status",
      ref_table_id: row.id,
    });
  };

  useEffect(() => {
    if (approvalLogsData?.body) {
      setHistoryLogs(approvalLogsData.body);
    }
  }, [approvalLogsData]);

  const currentDate = new Date().toISOString().split("T")[0];

  const initialRequest = {
    ref_no: "",
    limit: 10,
    offset: 0,
    mobile: "",
    name: "",
    start_date: "",
    end_date: "",
  };
  const [request, setRequest] = useState(initialRequest);

  const clearFilters = () => {
    setRequest(initialRequest);
  };

  const [
    getallCouponRequestList,
    { data: couponRequestListData, error: couponRequestListError, isLoading: couponRequestListIsLoading },
  ] = useGetAllCouponsRequestsMutation();

  const [
    getallCouponRequestListCsv,
    { data: couponRequestListCsvData, error: couponRequestListCsvError },
  ] = useGetAllCouponsRequestsMutation();

  // useEffect(() => {
  //   const hasViewPermission = hasPermission("ozoneCouponRequestList");
  //   if (!hasViewPermission) {
  //     navigate(`/genefied/${getVendorName()}/`);
  //   }
  //   fetchCouponRequestListFunction();
  // }, [limit, offset]);

  useEffect(() => {
    // console.log("request", request);
    if (
      request.mobile === "" &&
      request.name === "" &&
      request.ref_no === "" &&
      request.start_date === "" &&
      request.end_date === ""
    ) {
      fetchCouponRequestListFunction();
    }
  }, [request]);

  const fetchCouponRequestListFunction = () => {
    getallCouponRequestList({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request
    });
  };

  const fetchCouponRequestListCsvFunction = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    getallCouponRequestListCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest
    });
  };

  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (couponRequestListCsvData && couponRequestListCsvData?.body?.data) {
      setCsvData(couponRequestListCsvData.body.data);
    }

    if (couponRequestListCsvError) {
      setCsvData(null);
    }
  }, [couponRequestListCsvData, couponRequestListCsvError])

  const [
    rejectCouponRequest,
    { data: rejectCouponRequestData, error: rejectCouponRequestError },
  ] = useRejectCouponsRequestsMutation();

  const [
    acceptCouponRequest,
    { data: acceptCouponRequestData, error: acceptCouponRequestError },
  ] = useAcceptCouponsRequestsMutation();

  const [
    checkCouponStatus,
    {
      data: couponStatusData,
      isLoading: couponStatusIsLoading,
      isError: couponStatusIsError,
      error: couponStatusError,
    },
  ] = useCheckCouponStatusMutation();


  const [
    updateCouponRequestStatus,
    { data: updateCouponRequestStatusData, error: updateCouponRequestStatusError },
  ] = useUpdateCouponStatusMutation();


  useEffect(() => {
    if (couponRequestListData && couponRequestListData.body) {
      // console.log("couponRequestListData", couponRequestListData);
      const arr = couponRequestListData.body?.data ? couponRequestListData.body.data : [];
      setTotalData(arr);
      setTotalRows(couponRequestListData.body?.total ? couponRequestListData.body.total : 0)
      fetchBatchWorkflowStatus(arr);
    }
    if (couponRequestListError) {
      toast.error("Some Error Occured", {
        id: "brandAddError",
      });
    }
  }, [couponRequestListData, couponRequestListError]);

  const submitActionModal = () => {
    const { type, rowId, isFinalApproval, remarks, couponCode, validUpto } = actionModal;

    if (type === "reject") {
      if (!remarks.trim()) {
        toast.error("Remarks are required for rejection");
        return;
      }
      rejectCouponRequest({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: rowId,
        body: {
          remarks: remarks.trim(),
        },
      });
      setActionModal(prev => ({ ...prev, isOpen: false }));
    } else if (type === "approve") {
      if (!isFinalApproval) {
        if (!remarks.trim()) {
          toast.error("Remarks are required for approval");
          return;
        }
        acceptCouponRequest({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          id: rowId,
          body: {
            remarks: remarks.trim(),
          },
        });
      } else {
        if (!couponCode.trim()) {
          toast.error(isVoucher ? "Voucher Code is required" : "Coupon Code is required");
          return;
        }
        if (!validUpto.trim()) {
          toast.error("Expiry date (Valid Upto) is required");
          return;
        }
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateRegex.test(validUpto) || isNaN(new Date(validUpto).getTime())) {
          toast.error("Invalid date format. Please use YYYY-MM-DD");
          return;
        }
        acceptCouponRequest({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          id: rowId,
          body: {
            coupon_code: couponCode.trim(),
            remarks: remarks.trim(),
            valid_upto: validUpto,
          },
        });
      }
      setActionModal(prev => ({ ...prev, isOpen: false }));
    } else if (type === "resolve") {
      if (!couponCode.trim()) {
        toast.error(isVoucher ? "Voucher Code is required" : "Coupon Code is required");
        return;
      }
      if (!validUpto.trim()) {
        toast.error("Expiry date (Valid Upto) is required");
        return;
      }
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(validUpto) || isNaN(new Date(validUpto).getTime())) {
        toast.error("Invalid date format. Please use YYYY-MM-DD");
        return;
      }
      updateCouponRequestStatus({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: rowId,
        body: {
          approval_status: "2",
          coupon_code: couponCode.trim(),
          remarks: remarks.trim(),
          valid_upto: validUpto,
        },
      });
      setActionModal(prev => ({ ...prev, isOpen: false }));
    }
  };

  useEffect(() => {
    if (acceptCouponRequestData) {
      toast.success("Request Accepted", {
        id: "acceptCouponRequestData",
      });
      setShowModal(false);
      setSelectedCouponRequest(null);
      fetchCouponRequestListFunction();
      return;
    }

    if (acceptCouponRequestError) {
      toast.error(`${acceptCouponRequestError.data?.message}`, {
        id: "acceptCouponRequestError",
      });
      return;
    }
  }, [acceptCouponRequestData, acceptCouponRequestError]);

  useEffect(() => {
    if (rejectCouponRequestData) {
      toast.success("Request rejected", {
        id: "rejectCouponRequestData",
      });
      setShowModal(false);
      setSelectedCouponRequest(null);
      fetchCouponRequestListFunction();
      setCheckStatusModal(false);
      return;
    }

    if (rejectCouponRequestError) {
      toast.error("Something went wrong", {
        id: "rejectCouponRequestError",
      });
      return;
    }
  }, [rejectCouponRequestData, rejectCouponRequestError]);

  const handleShowModal = (data) => {
    console.log("data", data);
    setSelectedCouponRequest(data);
    setShowModal(true);
  };

  const handleShowCheckStatusModal = (data) => {
    // console.log("handleShowCheckStatusModal", data);
    setSelectedCouponRequest(data)
    checkCouponStatus({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      order_id: data.ref_no,
    });
    setCheckStatusModal(true);
  };

  useEffect(() => {

    if (checkStatusModal == false) {
      setSelectedCouponRequest(null);
    }
  }, [checkStatusModal]);


  useEffect(() => {
    if (couponStatusData) {
      console.log("couponStatusData", couponStatusData);
    }

    if (couponStatusError) {
      console.log("couponStatusError", couponStatusError);
    }
  }, [couponStatusData, couponStatusError]);

  const [getAuthToken, { data: authTokenData, error: authTokenError }] =
    useGetTokenMutation();

  useEffect(() => {
    toast.dismiss();
    if (authTokenData) {
      console.log("authTokenData", authTokenData);
      toast.success(authTokenData.message, {
        id: "authTokenSuccess",
      });
      fetchCouponRequestListFunction();
    }

    if (authTokenError) {
      console.log("authTokenError", authTokenError);
      toast.error("Something went wrong", { id: "authTokenError" });
    }
  }, [authTokenData, authTokenError]);

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      cell: (row) => row.name,
      sortable: true,
    },
    {
      name: "Mobile",
      cell: (row) => row.mobile,
      sortable: true,
      width: "120px",
    },
    {
      name: "Email",
      cell: (row) => row.email,
      sortable: true,
      width: "200px",
    },
    {
      name: "Ref No",
      cell: (row) => row.ref_no,
      sortable: true,
      width: "200px",
    },

    {
      name: isVoucher ? "Voucher Brand Code" : "Coupon Brand Code",
      cell: (row) => row.brand_product_code,
      sortable: true,
      width: "200px",
    },
    {
      name: "Brand Name ",
      cell: (row) => row.brand_name,
      sortable: true,
    },
    {
      name: isVoucher ? "Voucher Value" : "Coupon Value",
      cell: (row) => row.coupon_value,
      sortable: true,
    },
    {
      name: "Denomination",
      cell: (row) => row.denomination,
      sortable: true,
    },
    {
      name: "Remarks ",
      cell: (row) => row.remarks,
      sortable: true,
    },
    {
      name: "Sent on",
      cell: (row) => row.sent_on && new Date(row.sent_on).toLocaleString(),
      sortable: true,
    },
    {
      name: isVoucher ? "Voucher Status" : "Coupon Status",
      cell: (row) => {
        const ws = rowWorkflowStatus[row.id];
        if (ws && !ws.no_workflow) {
          const historyBtn = (
            <button
              onClick={() => openHistory(row)}
              style={{
                display: "inline-flex", alignItems: "center", gap: "3px",
                fontSize: "10px", fontWeight: 600, padding: "2px 7px",
                borderRadius: "12px", border: "1px solid #6366f1",
                color: "#6366f1", background: "#eef2ff",
                cursor: "pointer", marginTop: "4px", letterSpacing: "0.02em",
                transition: "background 0.15s",
              }}
              onMouseEnter={e => e.currentTarget.style.background = "#e0e7ff"}
              onMouseLeave={e => e.currentTarget.style.background = "#eef2ff"}
            >
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              History
            </button>
          );

          const levelPill = (
            <span style={{
              fontSize: "9px", fontWeight: 700, padding: "1px 6px",
              borderRadius: "10px", background: "#f1f5f9", color: "#64748b",
              letterSpacing: "0.03em", marginBottom: "2px",
            }}>
              Level {ws.current_level}/{ws.total_levels}
            </span>
          );

          if (ws.is_fully_approved || row.approval_status === "2") {
            return (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "3px" }}>
                <span className="font-bold text-green-500">Accepted</span>
                {historyBtn}
              </div>
            );
          }
          if (ws.is_rejected || row.approval_status === "3") {
            return (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "3px" }}>
                <span className="font-bold text-red-500">Rejected</span>
                {historyBtn}
              </div>
            );
          }

          if (ws.can_approve) {
            return (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                {levelPill}
                <div style={{ display: "flex", gap: "4px" }}>
                  <button
                    onClick={() => handleOpenActionModal(row, "approve")}
                    style={{
                      display: "inline-flex", alignItems: "center", gap: "3px",
                      fontSize: "11px", fontWeight: 600, padding: "4px 9px",
                      borderRadius: "6px", border: "none",
                      background: "linear-gradient(135deg,#16a34a,#15803d)",
                      color: "#fff", cursor: "pointer",
                      boxShadow: "0 1px 3px rgba(22,163,74,0.35)",
                      transition: "opacity 0.15s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                    onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                  >
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    Accept
                  </button>
                  <button
                    onClick={() => handleOpenActionModal(row, "reject")}
                    style={{
                      display: "inline-flex", alignItems: "center", gap: "3px",
                      fontSize: "11px", fontWeight: 600, padding: "4px 9px",
                      borderRadius: "6px", border: "none",
                      background: "linear-gradient(135deg,#dc2626,#b91c1c)",
                      color: "#fff", cursor: "pointer",
                      boxShadow: "0 1px 3px rgba(220,38,38,0.35)",
                      transition: "opacity 0.15s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                    onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                  >
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    Reject
                  </button>
                </div>
                {historyBtn}
              </div>
            );
          }

          // Not this user's turn
          return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "3px" }}>
              <span style={{
                display: "inline-flex", alignItems: "center", gap: "4px",
                fontSize: "11px", fontWeight: 600, padding: "4px 10px",
                borderRadius: "6px", background: "#fffbeb", color: "#b45309",
                border: "1px solid #fde68a",
              }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                Pending L{ws.current_level}/{ws.total_levels}
              </span>
              {historyBtn}
            </div>
          );
        }
        return (
          <span
            className={`font-bold flex justify-center items-center ${getApprovalStatusColor(
              row,
            )}`}
          >
            {row.approval_status === "1" && "Pending"}
            {row.approval_status === "2" && "Accepted"}
            {row.approval_status === "3" && "Rejected"}
            {row.approval_status === "4" && (
              <button
                onClick={() => handleShowCheckStatusModal(row)}
                className="bg-green-500 rounded  px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal flex justify-center items-center text-white hover:bg-green-600 focus:outline-none focus:ring focus:border-green-400"
              >
                Status
              </button>
            )}
          </span>
        );
      },
      sortable: true,
      width: "160px",
    },
    {
      name: "Created At",
      cell: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
    {
      name: "",
      cell: (row) => (
        <div className="flex space-x-1 items-center">
          <button
            onClick={() => handleShowModal(row)}
            className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
          >
            <AiFillEye className="mr-1" />
            View
          </button>
        </div>
      ),
      minWidth: "100px",
    },
  ];

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;

  const handleChangeStatus = (data, approval_status) => {

    // console.log("handleChangeStatus", data, approval_status);
    // Prompt for remarks
    let remarks = window.prompt("Enter Remarks..");
    remarks = remarks && remarks.trim();
    if (remarks == null) return;
    if (remarks?.length == 0) return;

    // Prompt for valid upto date
    let validUpto = window.prompt("Enter Valid Upto (YYYY-MM-DD) ..");
    validUpto = validUpto && validUpto.trim();
    if (validUpto == null) return;
    if (validUpto?.length == 0) return;

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(validUpto) || isNaN(new Date(validUpto).getTime())) {
      toast.error('Invalid date format for Valid Upto. Please use YYYY-MM-DD');
      return;
    }

    updateCouponRequestStatus({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: data.id,
      body: {
        approval_status: approval_status,
        remarks: remarks,
        valid_upto: validUpto,
      },
    });
  }

  useEffect(() => {
    if (updateCouponRequestStatusData) {
      console.log("updateCouponRequestStatusData", updateCouponRequestStatusData)
      setCheckStatusModal(false);
      fetchCouponRequestListFunction();

    }

    if (updateCouponRequestStatusError) {
      console.log("updateCouponRequestStatusError", updateCouponRequestStatusError)
      setCheckStatusModal(false);
      fetchCouponRequestListFunction();
    }
  }, [updateCouponRequestStatusData, updateCouponRequestStatusError])


  // console.log("selectedCOuponRequest", selectedCouponRequest);

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Coupon Request List
            <LinksComponent />
          </div>

          <div className="p-3">
            <div class="flex justify-between">
              <div className="flex gap-2 mb-2">
                {/* <div className="mb-2"> */}
                <CustomExport fetchData={fetchCouponRequestListCsvFunction} data={csvData} defaultColumnExport={[
                  "name",
                  "mobile",
                  "email",
                  "ref_no",
                  "user_type",
                  "brand_name",
                  "brand_product_code",
                  "coupon_value",
                  "denomination",
                ]}
                  filename="coupon_request_list"
                />
                {/* </div> */}

                <button
                  className="btn btn-outline-primary clear-both float-right "
                  onClick={() => {
                    getAuthToken({
                      token: sessionStorage.getItem("access_token"),
                      tenant_id: JSON.parse(
                        sessionStorage.getItem("vendorData"),
                      ).tenant_id,
                    });
                  }}
                >
                  Refresh Auth Token
                </button>
              </div>
            </div>

            <div className=" p-3 w-full bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                data={totalData}
                totalRows={totalRows}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              >
                <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                  <div className="flex  space-x-2 justify-end">
                    <div className="w-52 h-10 ">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Mobile
                        </label>
                        <input
                          type="search"
                          id="default-search"
                          className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="Mobile..."
                          required
                          value={request.mobile}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return { ...prevState, mobile: newValue };
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="w-52 h-10 ">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Ref No
                        </label>
                        <input
                          type="search"
                          id="default-search"
                          className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="Ref No."
                          required
                          value={request.ref_no}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return { ...prevState, ref_no: newValue };
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="w-52 h-10 ">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Name
                        </label>
                        <input
                          type="search"
                          id="default-search"
                          className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="Name..."
                          required
                          value={request.name}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return { ...prevState, name: newValue };
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="w-32 h-10 ">
                      <div className="relative searchin">
                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          Start Date
                        </label>
                        <input
                          type="date"
                          id="default-search"
                          className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="Start Date"
                          value={request.start_date}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return {
                                ...prevState,
                                start_date: newValue,
                              };
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="w-44 h-10 ">
                      <div className="relative searchin">
                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          End Date
                        </label>
                        <input
                          type="date"
                          id="default-search"
                          className="w-full px-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          placeholder="End Date"
                          value={request.end_date}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setRequest((prevState) => {
                              return {
                                ...prevState,
                                end_date: newValue,
                              };
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div className="flex flex-row  gap-2 h-10">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          &nbsp;
                        </label>
                        <button
                          className="btn btn-outline-primary clear-both float-right  p-2"
                          onClick={() => {
                            fetchCouponRequestListFunction();
                          }}
                        >
                          Search
                        </button>
                      </div>
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          &nbsp;
                        </label>
                        <button
                          className="btn btn-outline-primary clear-both float-right p-2"
                          onClick={() => {
                            clearFilters();
                          }}
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </DataTableComponent>
            </div>
          </div>
        </div>

        {showModal && (
          <ModalComponent
            size={"2xl"}
            data={"nadnandand"}
            show={showModal}
            setShow={setShowModal}
          >
            <div className="w-full p-3">
              <div className="w-full flex justify-center ">
                <div className="bg-white p-8">
                  <h2 className="text-2xl font-bold mb-4">
                    {selectedCouponRequest.brand_name}
                  </h2>
                  <img
                    className="mb-4 rounded-lg w-full h-32 object-cover"
                    src={selectedCouponRequest.brand_image}
                    alt={selectedCouponRequest.brand_product_code}
                  />
                  <p className="mb-4 text-gray-700">
                    {selectedCouponRequest.descriptions}
                  </p>
                  <div className="mb-2">
                    <strong>Name:</strong> {selectedCouponRequest.name}
                  </div>
                  <div className="mb-2">
                    <strong>Email:</strong> {selectedCouponRequest.email}
                  </div>
                  <div className="mb-2">
                    <strong>Mobile:</strong> {selectedCouponRequest.mobile}
                  </div>
                  <div className="mb-4">
                    <strong>Location:</strong> {selectedCouponRequest.city},{" "}
                    {selectedCouponRequest.state}
                  </div>
                  <div className="mb-2">
                    <strong>Category:</strong> {selectedCouponRequest.category}
                  </div>
                  <div className="mb-2">
                    <strong>Redemption Type:</strong>{" "}
                    {selectedCouponRequest.redemption_type}
                  </div>
                  <div className="mb-2">
                    <strong>Approval Status:</strong>{" "}
                    <span
                      className={`font-bold ${getApprovalStatusColor(
                        selectedCouponRequest,
                      )}`}
                    >
                      {selectedCouponRequest.approval_status === "1" &&
                        "Pending"}
                      {selectedCouponRequest.approval_status === "2" &&
                        "Accepted"}
                      {selectedCouponRequest.approval_status === "3" &&
                        "Rejected"}
                    </span>
                  </div>
                  <div className="mb-2">
                    <strong>Coupon Value:</strong>{" "}
                    {selectedCouponRequest.coupon_value}
                  </div>
                  <div className="mb-2">
                    <strong>Denomination:</strong>{" "}
                    {selectedCouponRequest.denomination}
                  </div>
                  <div className="mt-4 overflow-y-auto max-h-40">
                    <strong>Terms & Conditions:</strong>
                    <p
                      className="overflow-y-auto"
                      dangerouslySetInnerHTML={{
                        __html: selectedCouponRequest.tnc,
                      }}
                    ></p>
                  </div>
                  <div className="flex flex-col items-center mt-4">
                    {(() => {
                      const ws = selectedCouponRequest ? rowWorkflowStatus[selectedCouponRequest.id] : null;
                      if (ws && !ws.no_workflow) {
                        return null;
                      }
                      return (
                        <div className="flex justify-center space-x-4">
                          {selectedCouponRequest.approval_status === "1" && (
                            <button
                              onClick={() => handleOpenActionModal(selectedCouponRequest, "approve")}
                              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 focus:outline-none focus:ring focus:border-green-400"
                            >
                              Accept
                            </button>
                          )}

                          {selectedCouponRequest.approval_status === "1" && (
                            <button
                              onClick={() => handleOpenActionModal(selectedCouponRequest, "reject")}
                              className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 focus:outline-none focus:ring focus:border-red-400"
                            >
                              Reject
                            </button>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </ModalComponent>
        )}

        {checkStatusModal && (
          <ModalComponent
            size={"lg"}
            data={"nadnandand"}
            show={checkStatusModal}
            setShow={setCheckStatusModal}
          >
            <div className="w-full p-3">
              <div className="w-full flex justify-center ">
                {couponStatusIsLoading ? (
                  <> Please wait </>
                ) : couponStatusIsError ? (
                  <>
                    <div className="space-y-4">
                      <p>Message: {couponStatusError?.data?.message}</p>
                      <p>
                        <p>Voucher Status : Not Granted </p>
                      </p>
                      <div className="flex justify-center space-x-4">
                        <button
                          className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                          onClick={() => handleOpenActionModal(selectedCouponRequest, "approve")}
                        >
                          Retry
                        </button>
                        <button
                          className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                          onClick={() => handleOpenActionModal(selectedCouponRequest, "reject")}
                        >
                          Reject
                        </button>
                      </div>
                    </div>
                  </>
                ) : (

                  couponStatusData &&
                  <>
                    <div className="space-y-4">
                      <p>Message: {couponStatusData?.message}</p>
                      <p>
                        Reference Number: {couponStatusData?.body?.reference_num}
                      </p>
                      <p>
                        External Order ID:{" "}
                        {couponStatusData?.body?.external_order_id}
                      </p>
                      {couponStatusData?.body?.voucher_details.map(
                        (voucherDetail, index) => (
                          <div key={index}>
                            <p>Product Name: {voucherDetail?.product_name}</p>
                            {/* <p>Voucher Name: {voucherDetail.voucher_name}</p> */}
                            {/* Rendering vouchers */}
                            {voucherDetail?.vouchers.map((voucher, idx) => (
                              <div key={idx}>
                                {/* <p>End Date: {voucher.end_date}</p>
                              <p>Value: {voucher.value}</p> */}
                                <p>Voucher GUID: {voucher?.voucher_guid}</p>
                                <p>Voucher Number: {voucher?.voucher_no}</p>
                                <p>Voucher Status: {voucher?.voucher_status}</p>
                                <p>Email Status: {voucher?.email_status}</p>
                                <p>SMS Status: {voucher?.sms_status}</p>
                                {/* <p>WhatsApp Status: {voucher.whatsapp_status}</p> */}
                              </div>
                            ))}
                            {/* Buttons for accepting and rejecting */}
                            <div className="flex justify-center space-x-4">
                              <button
                                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                                onClick={() => handleOpenActionModal(selectedCouponRequest, "resolve")}
                              >
                                Resolve
                              </button>
                              {/* <button
                                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                                onClick={() => handleReject(voucherDetail)}
                              >
                                Reject
                              </button> */}
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </ModalComponent>
        )}

        {historyModal && (
          <ModalComponent
            size={"lg"}
            show={historyModal}
            setShow={setHistoryModal}
          >
            <div className="w-full p-4">
              <h3 className="text-xl font-bold border-b pb-2 mb-4">Approval History</h3>
              {approvalLogsLoading ? (
                <div className="flex justify-center items-center py-6">
                  <div className="animate-spin rounded-full h-8 w-8 border-4 border-indigo-500 border-t-transparent" />
                </div>
              ) : historyLogs.length === 0 ? (
                <p className="text-center py-6 text-gray-400">No approval history found for this request</p>
              ) : (
                <ol className="relative border-l border-indigo-100 ml-3 space-y-4">
                  {historyLogs.map((log, idx) => {
                    const isApproved = log.status === "1" || log.status === "approved";
                    const isRejected = log.status === "0" || log.status === "rejected";
                    const dotColor   = isApproved ? "bg-green-500" : isRejected ? "bg-red-500" : "bg-yellow-400";
                    const badgeClass = isApproved
                      ? "bg-green-100 text-green-700"
                      : isRejected
                      ? "bg-red-100 text-red-700"
                      : "bg-yellow-100 text-yellow-700";
                    const statusLabel = isApproved ? "Approved" : isRejected ? "Rejected" : log.status;

                    return (
                      <li key={idx} className="ml-4">
                        <span className={`absolute -left-[5px] flex items-center justify-center w-2.5 h-2.5 rounded-full ring-4 ring-white ${dotColor}`} />
                        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100">
                          <div className="flex items-center justify-between mb-1">
                            <span className="text-xs font-semibold text-indigo-600">
                              Level {log.level}
                              {log.total_levels ? ` / ${log.total_levels}` : ""}
                            </span>
                            <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${badgeClass}`}>
                              {statusLabel}
                            </span>
                          </div>
                          <p className="text-xs font-medium text-gray-800">{log.user_name || "—"} ({log.user_role_name || "User"})</p>
                          {log.remarks && (
                            <p className="mt-1 text-xs text-gray-600 bg-white border border-gray-100 rounded p-1.5 italic">
                              "{log.remarks}"
                            </p>
                          )}
                          <p className="mt-1.5 text-[10px] text-gray-400 text-right">
                            {new Date(log.created_at).toLocaleString()}
                          </p>
                        </div>
                      </li>
                    );
                  })}
                </ol>
              )}
            </div>
          </ModalComponent>
        )}

        {actionModal.isOpen && (
          <ModalComponent
            size={"md"}
            show={actionModal.isOpen}
            setShow={(val) => setActionModal(prev => ({ ...prev, isOpen: val }))}
          >
            <div className="w-full p-6">
              <h3 className="text-xl font-bold border-b pb-2 mb-4">
                {actionModal.type === "reject" ? "Reject Request" : actionModal.type === "resolve" ? "Resolve Request Status" : "Approve Request"}
              </h3>
              <div className="space-y-4">
                {actionModal.type === "reject" || !actionModal.isFinalApproval ? (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Remarks
                    </label>
                    <textarea
                      rows={3}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                      placeholder="Enter remarks..."
                      value={actionModal.remarks}
                      onChange={(e) => setActionModal(prev => ({ ...prev, remarks: e.target.value }))}
                    />
                  </div>
                ) : (
                  <>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {isVoucher ? "Voucher Code" : "Coupon Code"}
                      </label>
                      <input
                        type="text"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        placeholder={isVoucher ? "Enter Voucher Code" : "Enter Coupon Code"}
                        value={actionModal.couponCode}
                        onChange={(e) => setActionModal(prev => ({ ...prev, couponCode: e.target.value }))}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Valid Upto Date (Expiry Date)
                      </label>
                      <input
                        type="date"
                        min={currentDate}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        value={actionModal.validUpto}
                        onChange={(e) => setActionModal(prev => ({ ...prev, validUpto: e.target.value }))}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Remarks
                      </label>
                      <textarea
                        rows={2}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        placeholder="Enter remarks..."
                        value={actionModal.remarks}
                        onChange={(e) => setActionModal(prev => ({ ...prev, remarks: e.target.value }))}
                      />
                    </div>
                  </>
                )}

                <div className="flex justify-end gap-3 pt-3 border-t">
                  <button
                    onClick={() => setActionModal(prev => ({ ...prev, isOpen: false }))}
                    className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={submitActionModal}
                    className={`px-4 py-2 text-white rounded-lg text-sm font-medium transition ${
                      actionModal.type === "reject"
                        ? "bg-red-600 hover:bg-red-700"
                        : "bg-green-600 hover:bg-green-700"
                    }`}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </ModalComponent>
        )}
      </div>
    </>
  );
};

const getApprovalStatusColor = (data) => {
  switch (data.approval_status) {
    case "1":
      return "text-yellow-500"; // Pending
    case "2":
      return "text-green-500"; // Accepted
    case "3":
      return "text-red-500"; // Rejected
    case "4":
      return "text-slate-600"; // Rejected
    default:
      return "text-gray-500";
  }
};
export default DynamicCouponRequestList;